import useTableFilters from "@/hooks/useTableFilters";
import DepartmentCombobox from "components/directus/department-combobox";
import TitleCombobox from "components/directus/title-combobox";
import GradesCombobox from "components/directus/grades-combobox";
import FunctionsCombobox from "components/directus/functions-combobox";
import SelectStatus from "components/select/status";
import { Button } from "ui/components/button";
import { Label } from "ui/components/label";

export default function OrganizationEmployeeFilters({
    filters,
    setFilters,
    setIsOpen,
    isOpen,
    defaultFilters,
    clearFilters,
}) {

    const {
        localFilters,
        applyFilters,
        clearLocalFilters,
        handleSetLocalFilters,
    } = useTableFilters({
        filters,
        setFilters,
        setIsOpen,
        clearFilters,
        initialFilters: {
            department: undefined,
            function: undefined,
            status: undefined,
            ...defaultFilters,
        },
    });

    return (
        <div className="w-full p-4 space-y-4">

            {/* Department Filter */}
            <div>
                <DepartmentCombobox
                    value={localFilters?.department?.id?._eq ?? ""}
                    onChange={(value) => {
                        handleSetLocalFilters({ ...localFilters, department: { id: { _eq: value } } });
                    }}
                    dependenton={isOpen}
                />
            </div>

            {/* Title Filter */}
            <div>
                <TitleCombobox
                    value={localFilters?.job_title?.id?._eq ?? ""}
                    onChange={(selectedItem) => {
                        handleSetLocalFilters({ ...localFilters, job_title: { id: { _eq: selectedItem } } });
                    }}
                    dependenton={isOpen}
                />
            </div>

            {/* Grade Filter */}
            <div>
                <GradesCombobox
                    value={localFilters?.grade?.id?._eq ?? ""}
                    onChange={(selectedItem) => {
                        handleSetLocalFilters({ ...localFilters, grade: { id: { _eq: selectedItem } } });
                    }}
                    dependenton={isOpen}
                />
            </div>

            {/* Function Filter */}
            <div>
                <FunctionsCombobox
                    value={localFilters?.function?._eq ?? ""}
                    onChange={(value) => {
                        handleSetLocalFilters({ ...localFilters, function: { _eq: value } });
                    }}
                    dependenton={isOpen}
                />
            </div>

            {/* Status Filter */}
            <div>
                <Label className="mb-2 text-sm">Status</Label>
                <SelectStatus
                    value={localFilters?.user?.status?._eq}
                    onChange={(value) => {
                        handleSetLocalFilters({ ...localFilters, user: { status: { _eq: value } } });
                    }}
                    collection="directus_users"
                />
            </div>

            {/* Action Buttons */}
            <div className="flex place-self-end gap-4">
                <Button variant="outline" onClick={clearLocalFilters}>
                    Clear
                </Button>
                <Button onClick={() => applyFilters()}>Apply</Button>
            </div>

        </div>
    );
}
